import React from 'react';
import {
    ClipboardList,
    Cpu,
    Users,
    Headphones,
    Handshake,
    MonitorDot,
    UserCheck,
    Sparkles
} from 'lucide-react';

const helpItems = [
    { label: "ITAM", icon: ClipboardList },
    { label: "ITOM", icon: Cpu },
    { label: "HRSD", icon: Users },
    { label: "CSM", icon: Headphones },
    { label: "CRM", icon: Handshake },
    { label: "SPM", icon: MonitorDot },
    { label: "FSM", icon: UserCheck },
    { label: "Now Assist", icon: Sparkles }
];

const WeCanAlsoHelpWithSection = () => {
    return (
        <section className="w-full bg-[#FFFFFF] pb-[70px] lg:pb-[100px] text-left">
            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px]">

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">

                    <div className="lg:col-span-5 flex flex-col gap-4">
                        <h2 className="font-sora font-[600] text-[32px] sm:text-[42px] lg:text-[48px] leading-[1.2] tracking-tight text-[#01386A]">
                            We can Also <span className="text-[#EA6B24]">Help With</span>
                        </h2>
                        <p className="font-graphik font-[400] text-[15px] sm:text-[17px] leading-relaxed text-[#555555]">
                            Accelerate your enterprise transformation with our specialized capabilities across the complete ServiceNow ecosystem.
                        </p>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-5">
                            {helpItems.map((item, index) => {
                                const IconComponent = item.icon;
                                return (
                                    <div
                                        key={index}
                                        className="h-[120px] sm:h-[135px] bg-[#F8F9FA] border border-[#01386A]/10 p-5 flex flex-col justify-between group hover:border-[#EA6B24]/40 hover:bg-[#FFFFFF] hover:shadow-md transition-all duration-300 cursor-pointer"
                                    >
                                        <div className="text-[#01386A] group-hover:text-[#EA6B24] transition-colors duration-300">
                                            <IconComponent size={26} strokeWidth={1.8} />
                                        </div>
                                        <span className="font-sora font-[600] text-[16px] sm:text-[18px] tracking-tight text-[#01386A] group-hover:text-[#EA6B24] transition-colors duration-300">
                                            {item.label}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default WeCanAlsoHelpWithSection;